import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { theme } from '../styles/theme';

const InfoContainer = styled.div`
  background: ${theme.colors.surface};
  border-radius: ${theme.shape.borderRadius}px;
  padding: ${theme.spacing(3)};
  margin-bottom: ${theme.spacing(3)};
  box-shadow: ${theme.elevation[2]};
`;

const InfoTitle = styled.h3`
  margin: 0 0 ${theme.spacing(2)} 0;
  font-size: ${theme.typography.h5.fontSize};
  font-weight: ${theme.typography.h5.fontWeight};
  color: ${theme.colors.onSurface};
`;


const InfoText = styled.p`
  margin: 0;
  font-size: ${theme.typography.body2.fontSize};
  color: ${theme.colors.onSurfaceVariant};
  line-height: ${theme.typography.body2.lineHeight};
`;

const DirectionInfo = styled.div`
  background: ${theme.colors.surfaceVariant};
  border-radius: ${theme.shape.borderRadius}px;
  padding: ${theme.spacing(2)};
  margin-top: ${theme.spacing(2)};
  border-left: 3px solid ${theme.colors.primary};
`;

const DirectionText = styled.div`
  font-size: ${theme.typography.caption.fontSize};
  color: ${theme.colors.onSurface};
  font-weight: ${theme.typography.caption.fontWeight};
`;

const PriceInfo: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <InfoContainer>
      <InfoTitle>{t('pricingInformation')}</InfoTitle>

      <InfoText>
        {t('allPricesEur')}
      </InfoText>

      <DirectionInfo>
        <DirectionText>
          {t('northbound')}
          <br />
          {t('germanVat')}
        </DirectionText>
      </DirectionInfo>
    </InfoContainer>
  );
};

export default PriceInfo;